const KEY_CODES = {
  leftArrow: 37,
  rightArrow: 39,
};

export default {
  KEY_CODES,
};
